import React from "react"
import { useLayout } from "contexts/components/LayoutContext"
import { useGeneralSettings } from "./useGeneralSettings"

interface UseMainOfficeNumberParams {
  hasDisabledCustomTrackingNumber?: boolean
}

export const useMainOfficeNumber = ({
  hasDisabledCustomTrackingNumber = false,
}: UseMainOfficeNumberParams) => {
  const { customTrackingNumber } = useLayout()
  const { trackingNumbers, usePhoneNumberNotTrackingNumber } =
    useGeneralSettings()

  const mainOfficeTrackingPhoneNumber =
    trackingNumbers.length > 0 ? trackingNumbers[0]?.trackingNumber : ""
  const mainOfficeSinglePhoneNumber =
    trackingNumbers.length > 0 ? trackingNumbers[0]?.phoneNumber : ""

  const mainOfficeNumber = usePhoneNumberNotTrackingNumber
    ? mainOfficeSinglePhoneNumber
    : mainOfficeTrackingPhoneNumber

  const customNumber = customTrackingNumber
    ? customTrackingNumber
    : mainOfficeNumber

  const trackingNumber = hasDisabledCustomTrackingNumber
    ? mainOfficeNumber
    : customNumber

  return {
    mainOfficeNumber: trackingNumber,
  }
}
